import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Screen } from "../components/Screen";
import { api } from "../api/client";
import { formatUAH } from "../utils/format";
import type { Proposal } from "@karat/shared";

/**
 * п.18-19/24 ТЗ: клієнт відкриває готову персональну пропозицію за deep link і одразу бачить
 * її, без головного меню. Генерація пропозиції з внутрішньої системи консультанта — поза цією
 * ітерацією (див. план реалізації), але цей екран уже вміє показати запис, якщо він є в БД
 * (POST /api/proposals — готовий ендпоінт для майбутньої інтеграції).
 */
export function ProposalView() {
  const { id = "" } = useParams();
  const [proposal, setProposal] = useState<Proposal | null | undefined>(undefined);

  useEffect(() => {
    api
      .get<Proposal>(`/api/proposals/${id}`)
      .then(setProposal)
      .catch(() => setProposal(null));
  }, [id]);

  if (proposal === undefined) return <Screen title="Завантаження…"><div className="loading-row">Завантаження…</div></Screen>;
  if (proposal === null) return <Screen title="Пропозицію не знайдено">Можливо, посилання застаріло.</Screen>;

  return (
    <Screen title="Ваша персональна пропозиція">
      <div className="card" style={{ padding: 16 }}>
        <div style={{ fontWeight: 700, fontSize: 17 }}>
          {proposal.carModelName} {proposal.carTrimName}
        </div>
        {proposal.colorName && <div style={{ color: "var(--color-text-secondary)" }}>{proposal.colorName}</div>}
        <div className="price" style={{ fontSize: 24, margin: "12px 0" }}>
          {formatUAH(proposal.priceUAH)}
        </div>
        {proposal.tradeInEstimateUAH !== null && proposal.tradeInEstimateUAH !== undefined && (
          <>
            <div className="section-title" style={{ margin: "8px 0 4px" }}>
              Ваш автомобіль
            </div>
            <div>{formatUAH(proposal.tradeInEstimateUAH)}</div>
            <div className="section-title" style={{ margin: "8px 0 4px" }}>
              Ваша доплата
            </div>
            <div style={{ fontWeight: 700 }}>{formatUAH(proposal.priceUAH - proposal.tradeInEstimateUAH)}</div>
          </>
        )}
      </div>
    </Screen>
  );
}
